

























































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import UpdateWorkerTempEmergencyDetailsRequest from '@/models/Workers/UpdateWorkerTempEmergencyDetailsRequest';

@Component({
  components: {  },
    name: 'WorkerTempEmergencyDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public worker = new WorkerDto();
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateWorkerTempEmergencyDetailsRequest();
    request.updatedAt = this.worker.updatedAt;
    request.emergencyContactName = this.worker.emergencyContactName;
    request.emergencyContactPhoneNumber = this.worker.emergencyContactPhoneNumber;
  
    await WorkerDetailsModule.editTempEmergencyDetails(request)
    this.dialog = false;
  }


  
}
